export default __webpack_public_path__ + "static/media/testSong-3.b1c1bd45.mp3";